module.exports = __webpack_public_path__ + "img/icon3.4bf0c7ea.jpg";